import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import {ReservationService} from '@app/_components/reservation';

@Component({
    selector: 'app-open-unit',
    templateUrl: './open-unit.component.html',
    providers: [MessageService, ConfirmationService],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class OpenUnitComponent implements OnInit {
  @Input() housekeepingReport: any;
	  constructor(
    private reservationService: ReservationService,
    private dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) data: any) {
		// 	this.showFilter = data?.showFilter;
		// this.showPagination = data?.showPagination;
	}
  groupedData: { range: string; items: string[] }[] = [];

  ngOnInit(): void {
    const groups: { [key: string]: { propertyCode: string; availableDays: number }[] } = {
      '1–10': [],
      '11–20': [],
      '21–30': [],
      '>30': []
    };
    this.housekeepingReport.openUnitSummaries.forEach(item => {
      if (item.availableDays <= 10) {
        groups['1–10'].push(item);
      } else if (item.availableDays <= 20) {
        groups['11–20'].push(item);
      } else if (item.availableDays <= 30) {
        groups['21–30'].push(item);
      } else {
        groups['>30'].push(item);
      }
    });
    this.groupedData = Object.keys(groups).map(range => {
      const sorted = groups[range]
        .sort((a, b) => a.availableDays - b.availableDays)
        .map(item => `${item.propertyCode} (${item.availableDays})`);
      return { range, items: sorted };
    });
	}
}
